import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { ConfirmDialog } from '../../common/views/modals/confirmDialog/ConfirmDialog';
import { coverEditorMessages } from '../coverEditorMessages';

interface LeaveDialogProps {
  isOpen: boolean;
  isBusy: boolean;
  /** The last save failed: "Save and leave" may fail again, so the dialog says what is lost. */
  isSaveFailed: boolean;
  onSaveAndLeave: () => void;
  onStay: () => void;
}

/**
 * A leave of the editor while the last changes are not saved yet (design cover-editor e5): the
 * design saves by itself, so this shows only in the second after a change or after a failed save.
 */
const LeaveDialogComponent: React.FC<LeaveDialogProps> = ({ isOpen, isBusy, isSaveFailed, onSaveAndLeave, onStay }) => {
  const intl = useIntl();
  return (
    <ConfirmDialog
      isOpen={isOpen}
      tone="neutral"
      title={intl.formatMessage(coverEditorMessages.leaveTitle)}
      description={intl.formatMessage(
        isSaveFailed ? coverEditorMessages.leaveTextFailed : coverEditorMessages.leaveText
      )}
      confirmLabel={intl.formatMessage(coverEditorMessages.leaveConfirm)}
      cancelLabel={intl.formatMessage(coverEditorMessages.leaveStay)}
      isBusy={isBusy}
      onConfirm={onSaveAndLeave}
      onCancel={onStay}
    />
  );
};

export const LeaveDialog = TypedMemo(LeaveDialogComponent);
